import { SIDE_NAV_WIDTH_COLLAPSED_PX, SIDE_NAV_WIDTH_PX } from "globalStylesVariables";
import { createUseStyles } from "react-jss";
import { BP_MEDIA_QUERIES } from "utils/ui/breakpoints";

export const useStyles = createUseStyles({
  navigationBar: {
    "display": "flex",
    "flexDirection": "column",
    "justifyItems": "flex-start",
    "alignItems": "stretch",
    "userSelect": "none",
    "overflow": "hidden",
    "transition": "0.6s ease width",
    "willChange": "width",
    "height": "100%",
    "backgroundColor": "var(--sidebar)",
    "color": "var(--sidebar-foreground)",
    "paddingTop": "var(--spacing-x9, 36px)",
    "width": `${SIDE_NAV_WIDTH_PX}px`,
    "&$minimized": { width: `${SIDE_NAV_WIDTH_COLLAPSED_PX}px` },
    [BP_MEDIA_QUERIES.FORTY]: {
      paddingTop: "var(--spacing-x3, 12px)",
    },
  },
  minimized: {},
  scrollContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    flex: "1 1 auto",
  },
});
